import axios from '@/axios'

// 首页接口（获取模块）
export const homeElement = (data) => axios.post('/allInOne/homeElement', data)
export const homeElementByParentsId = (data) => axios.post('/home/homeElementByParentsId', data)

// 获取仲裁院名字
export const getCourtName = (data) => axios.post('/home/getCourtName', data)

// 登录接口
export const login = (data) => axios.post('/aisoon/userLogin', data)

// 刷新token
export const refreshToken = (data) => axios.post('/user/refreshToken', data)

// 退出登录
export const loginOut = (data) => axios.post('/user/loginOut', data)

// 共道登录
// export const guanghuLogin = (data) => axios.post('/oauth/getLoginUrl', data)

// export const guanghuToken = (data) => axios.post('/oauth/callback', data)

// 获取token
export const aaaa = (data) => axios.post('/test/getLoginRequestJSON', data)

//广互立案认证
export const guanghuLogin = (data) => axios.post('/oauth/queryOauthStatus', data)

//登录
export const loginByIdCard = (data) => axios.post('/allInOne/loginByIdCard', data)
//法律法规
export const lawList = (data) => axios.post('/allInOne/laws', data)

// 仲裁请求字典表
export const arbitrationClaimsDic = (data) => axios.post('/allInOne/queryDictionary', data)

// 仲裁请求提交接口
export const arbitrationClaimsRegisterCase = (data) => axios.post('/allInOne/registerCase', data)

// 仲裁请求查询单位信息接口
export const arbitrationClaimsQueryCompanyList = (data) => axios.post('/allInOne/queryCompanyList', data)


// WEBPACK FOOTER //
// ./src/api/home.js